:host {
  display: block;
  max-width: 100%;
  overflow: hidden;
  padding: 0 calc(var(--spacer) * 3);
  background: var(--white-layout-301-level-0-elevation);
}

.resources-count {
  margin-left: 4px;
  color: var(--text-color-on-light-50);
}

show-more-items-in-bulk {
  padding-bottom: var(--spacer);
  cursor: pointer;
}

.circle {
  width: var(--spacer);
  height: var(--spacer);
  border-radius: 50%;
  background-color: var(--chart-101-pressed-dividers);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
  margin-top: 2px;

  .count {
    font-size: var(--body-size-xsmall);
    color: var(--main-titles-inputs-600, #000000e5);
  }

  &.has-count {
    min-width: 20px;
    min-height: 20px;
  }
}

.header-icon {
  margin-right: 4px;
  margin-top: 2px;
}

.title-container {
  .counter {
    padding-left: calc(var(--spacer) / 2);
    color: var(--text-color-on-light-50);
  }
  .section-title {
    color: var(--text-color-on-light-50);
  }
}

gz-tooltip[class*='label'] {
  color: var(--body-text-arrows-400);
}
